import {
  GraphQLEnumType,
  GraphQLInterfaceType,
  GraphQLList,
  GraphQLNamedType,
  GraphQLNonNull,
  GraphQLObjectType,
  GraphQLScalarType,
  GraphQLType,
  GraphQLUnionType,
  isInputType,
} from 'graphql';

import { ReferenceCategorySlug } from 'src/app/graph/routes';
import { assertUnreachable } from 'src/lib/assertUnreachable';

const getSubjectSlugByGraphQLNamedType = (
  type: GraphQLNamedType,
): ReferenceCategorySlug => {
  if (type instanceof GraphQLScalarType) return 'scalars';
  if (type instanceof GraphQLObjectType) return 'objects';
  if (type instanceof GraphQLInterfaceType) return 'interfaces';
  if (type instanceof GraphQLUnionType) return 'unions';
  if (type instanceof GraphQLEnumType) return 'enums';
  if (isInputType(type)) return 'inputs';
  assertUnreachable(type);
};

export const getSubjectSlugByGraphQLType = (
  type: GraphQLType,
): ReferenceCategorySlug => {
  if (type instanceof GraphQLList)
    return getSubjectSlugByGraphQLType(type.ofType);
  if (type instanceof GraphQLNonNull)
    return getSubjectSlugByGraphQLType(type.ofType);
  return getSubjectSlugByGraphQLNamedType(type);
};
